export default (): string => {
  return 'notification-' + Date.now() + '-' + Math.floor(Math.random() * 1000)
}
